import { mapGetters, mapActions, mapMutations } from "vuex";

import * as marketplaceStore from "@/store/Marketplace";

export { marketplaceStore };

/**
 * Search store.
 *
 * @param {('actions' | 'getters' | 'mutations')[]} without - Exclude store actions or mutation or getters.
 */
export const createMarketplaceMixin = (without = []) => {
  const actions = !without.includes("actions")
    ? mapActions(marketplaceStore.moduleName, Object.keys(marketplaceStore.actionTypes))
    : {};
  const getters = !without.includes("getters")
    ? mapGetters(marketplaceStore.moduleName, Object.keys(marketplaceStore.getterTypes))
    : {};
  const mutations = !without.includes("mutations")
    ? mapMutations(marketplaceStore.moduleName, Object.keys(marketplaceStore.mutationTypes))
    : {};

  return {
    methods: {
      ...actions,
      ...mutations
    },
    computed: {
      ...getters
    }
  };
};
